import firebase from 'firebase/compat/app';

const updateSalescenter = (salescenterId, updatedData) => {
  const firestore = firebase.firestore();

  return firestore.collection('salescenters').doc(salescenterId).set(updatedData, { merge: true });
};

export default updateSalescenter;
